import { render, staticRenderFns } from "./CombinedSalaryDataTable.vue?vue&type=template&id=5721e579"
import script from "./CombinedSalaryDataTable.vue?vue&type=script&lang=js"
export * from "./CombinedSalaryDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports